// Terms.tsx
import React, { useEffect, useState } from "react";

import { Typography, Stack } from "@mui/material";

import AppBar from "@/components/AppBar";
import { FormattedMessage } from "react-intl";
// import { getLocale } from "@/utils";

const Terms: React.FC = () => {
  const [policyText, setPolicyText] = useState("");

  useEffect(() => {
    // const locale = getLocale();
    // テキストファイルをフェッチして内容を読み込む
    fetch(`/policy_ja.txt`)
      .then((response) => response.text())
      .then((text) => setPolicyText(text));
  }, []);

  return (
    <AppBar title={<FormattedMessage id="policy.title" />}>
      <Stack padding={2}>
        <Typography variant="body1" paragraph style={{ whiteSpace: "pre-line" }}>
          {policyText}
        </Typography>
      </Stack>
    </AppBar>
  );
};

export default Terms;
